import { render, staticRenderFns } from "./DrainagePipe.vue?vue&type=template&id=543041e2&scoped=true"
import script from "./DrainagePipe.vue?vue&type=script&lang=js"
export * from "./DrainagePipe.vue?vue&type=script&lang=js"
import style0 from "./DrainagePipe.vue?vue&type=style&index=0&id=543041e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543041e2",
  null
  
)

export default component.exports